export interface NewsRouter {
  goToList(query?: string): void;
  goToDetail(id: string): void;
  goToEdit(query?: string): void;
  goToCreate(query: string): void;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NewsRouter = Symbol('NewsRouter');
